var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPreferencesIconsAuthentication = function SvgPreferencesIconsAuthentication(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.95 10.866.752.752a.85.85 0 0 0 .633.262h.89v.753a1.021 1.021 0 0 0 1.02 1.02h.753v.889c0 .234.093.459.257.626l.59.59a.834.834 0 0 0 .589.242h2.344a.733.733 0 0 0 .732-.732v-2.345a.832.832 0 0 0-.245-.592l-4.89-4.89a5.59 5.59 0 1 0-3.425 3.425ZM2.88 2.37a4.562 4.562 0 0 1 7.428 5.002.509.509 0 0 0 .11.559l5.06 5.061v1.976h-1.976l-.498-.498v-1.2a.656.656 0 0 0-.655-.656h-1.106V11.51a.655.655 0 0 0-.656-.655h-1.2l-.947-.948a.51.51 0 0 0-.56-.109 4.562 4.562 0 0 1-6.297-3.594 4.56 4.56 0 0 1 1.296-3.831l.002-.004Zm2.017 3.824a1.806 1.806 0 1 0 0-3.613 1.806 1.806 0 0 0 0 3.613Zm0-2.58a.775.775 0 1 1 0 1.553.775.775 0 0 1 0-1.554v.001Z",
    fill: "#63758D",
    fillRule: "nonzero"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPreferencesIconsAuthentication, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/preferences_icons_Authentication.1b59fc92.svg";
export { ForwardRef as ReactComponent };